import React, { useEffect, useRef, useState } from 'react'
import ConstantConsumptionStyle from './ConstantConsumption'
import Button from '../../../components/Button'
import { useNavigate } from 'react-router-dom'
import api from '../../../api'
import Layout from '../../../components/Layout'
import ClipLoader from 'react-spinners/ClipLoader'
import { isAxiosError } from 'axios'
import ConfirmModal from '../../../components/ComfirmModal'
import { get } from 'lodash'
import { useSelector } from 'react-redux'
import { ErrorModal, SuccessModal } from '../../../components/Modal'
import { formatNumberWithIntl } from '../../../lib/FormatNumbersWithIntl'
import { removeSpaces } from '../../../utils/removeSpaces'

const CreateJournalEntries = () => {
	const { getMe } = useSelector((state) => state.main)
	const navigation = useNavigate()
	const inputRef = useRef(null)
	const [isLoading, setIsLoading] = useState(false)
	const [date, setDate] = useState(new Date().toISOString().split('T')[0])
	const errorRef = useRef()
	const successModalRef = useRef()
	const [currency, setCurrency] = useState('USD')
	const [cashAccountsData, setCashAccountsData] = useState([])
	const [spendAccountsData, setSpendAccountsData] = useState([])
	const [formData, setFormData] = useState({
		CardCode: '', // На сейф
		CashAccount: '', // С кассы
		CashSum: 0,
		AccountCode: '',
	})
	const [btnLoading, setBtnLoading] = useState(false)
	const [remarks, setRemarks] = useState(null)
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')

	const handleSpendAccountClick = (event) => {
		if (inputRef.current) {
			inputRef.current.value = event.target.innerText
		}
		setFormData((prev) => ({
			...prev,
			CardCode: event.target.value,
		}))
	}

	const cashAccounts = async () => {
		const data = await api(
			`ChartOfAccounts?$select=Code,Name&$filter=${
				getMe?.Department2?.Name === 'Boshqaruv'
					? "startswith(Code, '5')"
					: `${
							currency === 'USD'
								? `Code eq '${getMe.U_CashAccount}'`
								: currency === 'UZS'
									? `Code eq '${getMe.U_CashUzsAccount}'`
									: ''
						}`
			} and (AcctCurrency eq '${currency}' or AcctCurrency eq '%23%23')`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		).then((res) => {
			return JSON.parse(res.data).value
		})
		setCashAccountsData(data)
		setFormData((prev) => ({
			...prev,
			CashAccount:
				get(getMe, 'Department2.Name', '') === 'Bosharuv'
					? data[0]?.Code
					: get(getMe, 'Department2.Name', '') !== 'Bosharuv' &&
						  currency === 'USD'
						? get(getMe, 'U_CashAccount', '')
						: get(getMe, 'Department2.Name', '') !== 'Bosharuv' &&
							  currency === 'UZS'
							? get(getMe, 'U_CashUzsAccount', '')
							: data[0]?.Code,
		}))
	}

	const typeSpend = async () => {
		const data = await api(
			`ChartOfAccounts?$select=Code,Name&$filter=${getMe?.Department2?.Name === 'Boshqaruv' ? "startswith(Code, '5')" : "ExternalCode eq '12'"} and (AcctCurrency eq '${currency}' or AcctCurrency eq '%23%23')`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		).then((res) => {
			return JSON.parse(res.data).value
		})
		setSpendAccountsData(data)
		setFormData((prev) => ({
			...prev,
			CardCode:
				getMe?.Department2?.Name === 'Boshqaruv'
					? data[1]?.Code
					: data[0]?.Code,
		}))
	}

	useEffect(() => {
		cashAccounts()
		typeSpend()
	}, [currency])

	const submitForm = () => {
		setConfirmationMessage([
			{
				name: 'Дата:',
				value: date,
			},
			{
				name: 'Валюта:',
				value: currency,
			},
			{
				name: 'С кассы:',
				value: `${cashAccountsData.find((item) => item.Code === formData.CashAccount)?.Name || ''} ${formData.CashAccount}`,
			},
			{
				name: 'На сейф:',
				value: `${spendAccountsData.find((item) => item.Code === formData.CardCode)?.Name}, ${formData.CardCode}`,
			},
			{
				name: 'Сумма:',
				value: `${formatNumberWithIntl(formData.CashSum)} ${currency}`,
			},
			{
				name: 'Комментарий:',
				value: `${remarks ? remarks : 'Нет'}`,
			},
		])
		setShowModal(true)
	}

	const handleConfirm = async () => {
		setShowModal(false)
		setBtnLoading(true)

		try {
			const response = await api
				.post('JournalEntries', {
					ReferenceDate: date + 'T00:00:00Z',
					U_DocNum: 'Journal',
					Memo: remarks ? remarks : null,
					U_Creator: getMe?.EmployeeID,
					JournalEntryLines: [
						{
							AccountCode: formData.CardCode,
							Debit: currency === 'USD' ? removeSpaces(formData.CashSum) : 0,
							Credit: 0,
							FCDebit: currency === 'UZS' ? removeSpaces(formData.CashSum) : 0,
							FCCredit: 0,
							FCCurrency: currency === 'UZS' ? currency : '',
							ContraAccount: formData.CashAccount,
						},
						{
							AccountCode: formData.CashAccount,
							Debit: 0,
							Credit: currency === 'USD' ? removeSpaces(formData.CashSum) : 0,
							FCDebit: 0,
							FCCredit: currency === 'UZS' ? removeSpaces(formData.CashSum) : 0,
							FCCurrency: currency === 'UZS' ? currency : '',
							ContraAccount: formData.CardCode,
						},
					],
				})
				.then((res) => {
					// try {
					// 	logsUrl.post('apis', {
					// 		company_name: COMPANY_NAME,
					// 		method: 'post',
					// 		path: `/VendorPayments`,
					// 		description: 'Создать постоянные расход',
					// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
					// 		body: JSON.stringify({
					// 			DocDate: date + 'T00:00:00Z',
					// 			DocType: 'rAccount',
					// 			CardCode: formData.CardCode,
					// 			CashAccount: formData.CashAccount,
					// 			Remarks: remarks ? remarks : null,
					// 			DocCurrency: currency,
					// 			CashSum: formData.CashSum,
					// 			PaymentAccounts: [
					// 				{
					// 					AccountCode: formData.CardCode,
					// 					SumPaid: formData.CashSum,
					// 				},
					// 			],
					// 		}),
					// 	})
					// } catch (err) {
					// 	errorRef.current?.open(
					// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
					// 	)
					// }
				})
			successModalRef.current?.open('Бугалтерский операция успешно создана!')

			// return JSON.parse(response.data).value
		} catch (err) {
			errorRef.current?.open(
				get(JSON.parse(err.response.data), 'error.message', ''),
			)
		} finally {
			setBtnLoading(false)
		}
	}

	const handleCancel = () => {
		setShowModal(false)
	}

	const handleDateChange = (event) => {
		setDate(event.target.value)
	}

	const handleCurrencyChange = (event) => {
		setCurrency(event.target.value)
		setSpendAccountsData([])
		setCashAccountsData([])
		if (inputRef.current) {
			inputRef.current.value = ''
		}
		setFormData((prev) => ({
			...prev,
			CashSum: 0,
			CardCode: null,
		}))
	}

	const handleClickAccountCode = (event) => {
		setFormData((prev) => ({
			...prev,
			CashAccount: event.target.value,
		}))
	}

	const handleRemarks = (event) => {
		setRemarks(event.target.value)
	}

	return (
		<Layout>
			<ConstantConsumptionStyle>
				<div className="container">
					<p className="productTitle text-xl font-bold text-center py-8">
						Создать принятие денег в кассу
					</p>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<div>
							<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
								<div>
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										Сумма
									</p>
									<input
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
										}
										type="text"
										onChange={(e) =>
											setFormData((prev) => ({
												...prev,
												CashSum: removeSpaces(e.target.value),
											}))
										}
										onWheel={(e) => e.target.blur()}
										value={formatNumberWithIntl(formData.CashSum)}
									/>
								</div>
								<div className="flex flex-col">
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										Валюта
									</p>
									<select
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
										}
										onChange={handleCurrencyChange}
									>
										<option value="USD">USD</option>
										<option value="UZS">UZS</option>
									</select>
								</div>

								<div className="flex flex-col">
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										Дата
									</p>
									<input
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full flex-1'
										}
										type="date"
										value={date}
										disabled={true}
										onChange={handleDateChange}
									/>
								</div>
							</div>
							<div className="flex items-center justify-between gap-20">
								<div>
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										С кассы
									</p>
									<select
										value={formData.CashAccount}
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md min-w-[200px]  w-full  flex-1'
										}
										onChange={handleClickAccountCode}
										disabled={
											get(getMe, 'Department2.Name', '') !== 'Boshqaruv'
										}
									>
										{cashAccountsData
											.filter((item) => item.Code !== formData.CardCode)
											.map((item) => {
												return (
													<option key={item.Code} value={item.Code}>
														{item.Name} - {item.Code}
													</option>
												)
											})}
									</select>
								</div>
								<div className="flex flex-col">
									<p className={'font-medium text-zinc-600 text-sm mb-1'}>
										На сейф
									</p>
									<select
										value={formData.CardCode}
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md min-w-[200px] w-full flex-1'
										}
										onChange={handleSpendAccountClick}
									>
										{spendAccountsData
											.filter((item) => item.Code !== formData.CashAccount)
											.map((item) => {
												return (
													<option key={item.Code} value={item.Code}>
														{item.Name} - {item.Code}
													</option>
												)
											})}
									</select>
								</div>
							</div>
							<div className="flex justify-end">
								<div className="">
									<p className={'font-medium text-zinc-600 text-sm mb-1 mt-10'}>
										Комментарий
									</p>
									<textarea
										className={
											'border-[1px] border-[#DFE2E9"] p-1 rounded-md min-w-[450px] w-full flex-1'
										}
										onChange={handleRemarks}
									/>
								</div>
							</div>
							<div className="flex justify-end mt-10 gap-10 w-full">
								<Button
									onClick={() => navigation(-1)}
									isLoading={btnLoading}
									className={'!bg-red-600 !w-full'}
									style={{ width: '100%' }}
								>
									Назад
								</Button>
								<Button
									onClick={submitForm}
									isLoading={btnLoading}
									disabled={
										!formData.CashAccount ||
										!formData.CardCode ||
										!(+formData.CashSum > 0)
									}
									style={{ width: '100%' }}
								>
									Добавить
								</Button>
							</div>
						</div>
					)}
				</div>
			</ConstantConsumptionStyle>

			<ConfirmModal
				show={showModal}
				data={confirmationMessage}
				onConfirm={handleConfirm}
				onCancel={handleCancel}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<SuccessModal
				getRef={(r) => {
					successModalRef.current = r
				}}
				onConfirm={() => {
					navigation('/journal-entries')
				}}
			/>
		</Layout>
	)
}

export default CreateJournalEntries
